import React from "react";
import './MobileBankingAppPage.css';
import MobileBankingAppSection from "../../Sections/MobileBankingAppSection/MobileBankingAppSection";

export default function MobileBankingAppPage(){
    return(
        <>
            <MobileBankingAppSection/>
        </>
    );
}